import styled, { css } from 'styled-components';

const Branding = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
`;

const CompanyLogoBody = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(7, 1fr);
  margin-top: 16px;
  position: relative;
`;

const CompanyLogo = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const CompanyLogoTitle = styled.div`
  margin-bottom: 8px;
`;

const CompanyLogoImage = styled.div`
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  cursor: pointer;
  padding: 7px;
  width: 100%;

  ${({ active }) =>
    active &&
    css`
      border: 1px solid var(--color-accent-primary-default);
    `}

  :hover {
    box-shadow: var(--shadow-s);
  }
`;

export { Branding, CompanyLogo, CompanyLogoBody, CompanyLogoImage, CompanyLogoTitle };
